import Element from './Element.js';

export default class Div extends Element
{
	get tagName()
	{
		return 'div';
	}
}